import React from "react";
import "../About/About.css";
import News from "../News/News";
import MovePoster from "../MovePoster/MovePoster";

const About = () => {
  return (
    <>
      <div className="post-ab">
        <div className="overlay-ab">
          <h1 className="text-ab">About Us</h1>
        </div>
      </div>

      <div className="text-center p-8">
        <h2 className="text-2xl font-bold mb-4 he">
          Journey Experts Ltd – Your Trusted Online Travel Partner
        </h2>
        <p className="het">
          Journey Experts is an online travel agency, working on the motives to
          provide its audience with a wide scope and range of travel and related
          services, which will help them, explore, divulge and create new
          memories by visiting new and exciting destinations all around the
          world. {" "}
        </p>
        <p className="het">
         The aim of the company is to provide its customers with
          suitable and affordable holiday and ticketing options, which being
          pocket friendly, are filled with great returns and smiles.
        </p>
      </div>

      <div
        className="text-center p-8"
        style={{ backgroundColor: "rgb(7 48 66 / 9%)" }}
      >
        <h2 className="text-2xl font-bold mb-4 he">
          Support When You Need It Most
        </h2>
        <p className="het">
         We work on a platform to provide smiles by having a dedicated team, always looking for your best interests and offering you tailor-made and suitable offers. Our expertise also lies in constant upgradation and research to find new and exciting places for our customers to visit and make the most off. 
        </p>
      </div>

      <MovePoster />

     

      <div
        className="text-center p-8"
        
      >
        <h2 className="text-2xl font-bold mb-4 he">
          Distinguished for Quality
        </h2>
        <p className="het">
        We are a team of travelers, and hence understand the need and point of view of a customer, who may simply be looking for a new place to holiday, a ticket back home, a honeymoon or family package, or a luxury business travel – we are there for all! – providing 100% customer support and dedicated after sales service. 
        </p>
      </div>
       <div className="text-center p-8" style={{ backgroundColor: "rgb(7 48 66 / 9%)" }}>
        <h2 className="text-2xl font-bold mb-4 he">Your Financial Security</h2>
        <p className="het jh">
        For your safety and peace of mind, we are ATOL and PTS protected. 
        </p>
      </div>

      <section className="why-section">
        <h2>Why Book with Journey Experts Ltd?</h2>
        <hr />
        <div className="why-container">
          <div className="why-box">
            <p className="why-heading">Expertise</p>
            <p className="why-text">
              Expert team with 20+ years in the industry
            </p>
          </div>
          <div className="why-box">
            <p className="why-heading">Protection</p>
            <p className="why-text">
              Fully ATOL protected for your financial security
            </p>
          </div>
          <div className="why-box">
            <p className="why-heading">Trusted</p>
            <p className="why-text">
              UK-registered and trusted travel provider{" "}
            </p>
          </div>
          <div className="why-box">
            <p className="why-heading">Experience</p>
            <p className="why-text">Over 10 years of proven experience</p>
          </div>
          <div className="why-box">
            <p className="why-heading">Convenience</p>
            <p className="why-text"> Easy and secure online booking</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
